import { render, staticRenderFns } from "./codelogin.vue?vue&type=template&id=2cfb7162"
import script from "./codelogin.vue?vue&type=script&lang=js"
export * from "./codelogin.vue?vue&type=script&lang=js"
import style0 from "./codelogin.vue?vue&type=style&index=0&id=2cfb7162&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cfb7162')) {
      api.createRecord('2cfb7162', component.options)
    } else {
      api.reload('2cfb7162', component.options)
    }
    module.hot.accept("./codelogin.vue?vue&type=template&id=2cfb7162", function () {
      api.rerender('2cfb7162', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/login/codelogin.vue"
export default component.exports